import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="segmented"
//
// A pill/segmented toggle — the same control as the campaign wizard's
// "Use a saved template / Write a new one": one rounded bg-neutral-100 track
// with the active segment raised on a white pill. Shows the matching content
// pane and hides the rest. No page navigation.
//
// Targets: tab (buttons, each data-tab="x"), content (panes, each data-tab="x")
// Value:   active — the data-tab to open first.
export default class extends Controller {
  static targets = ["tab", "content"];
  static values = { active: String };

  // Active / inactive segment classes, matching styleSegment in the wizard.
  static ON = [
    "bg-white",
    "text-neutral-900",
    "shadow-xs",
    "dark:bg-neutral-700",
    "dark:text-white",
  ];
  static OFF = [
    "text-neutral-500",
    "hover:text-neutral-700",
    "dark:text-neutral-400",
    "dark:hover:text-neutral-200",
  ];

  connect() {
    this.show(this.activeValue || this.tabTargets[0]?.dataset.tab);
  }

  switch(event) {
    event.preventDefault();
    this.show(event.currentTarget.dataset.tab);
  }

  show(tabId) {
    this.tabTargets.forEach((btn) => {
      const on = btn.dataset.tab === tabId;
      this.constructor.ON.forEach((c) => btn.classList.toggle(c, on));
      this.constructor.OFF.forEach((c) => btn.classList.toggle(c, !on));
    });
    this.contentTargets.forEach((pane) => {
      pane.classList.toggle("hidden", pane.dataset.tab !== tabId);
    });
  }
}
